import { MapPin, Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "./data";

const quickLinks = [
    { label: "Home", href: "#home" },
    { label: "About", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Appointment", href: "#appointment" },
    { label: "Contact", href: "#contact" },
];

export const Footer = () => (
    <footer className="bg-slate-950 text-slate-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-3">
            <div>
                <a href="#home" data-testid="footer-logo-link" className="flex items-center gap-2.5">
                    <span className="h-9 w-9 rounded-xl bg-teal-600 flex items-center justify-center">
                        <svg viewBox="0 0 24 24" className="h-4.5 w-4.5 h-[18px] w-[18px] text-white" fill="currentColor" aria-hidden="true">
                            <path d="M12 2C8.5 2 6 4.2 6 7.5c0 2.4.9 4.1 1.5 6.2.6 2.2.9 4.6 1.4 6.6.2.9 1.5.9 1.8-.1.4-1.5.7-4.2 1.3-4.2s.9 2.7 1.3 4.2c.3 1 1.6 1 1.8.1.5-2 .8-4.4 1.4-6.6.6-2.1 1.5-3.8 1.5-6.2C18 4.2 15.5 2 12 2z" />
                        </svg>
                    </span>
                    <span className="leading-tight">
                        <span className="block font-semibold text-white text-[15px]">The Tooth Care</span>
                        <span className="block text-[10px] font-semibold uppercase tracking-[0.18em] text-teal-400">Dental Clinic</span>
                    </span>
                </a>
                <p className="mt-5 text-sm leading-relaxed text-slate-400 max-w-xs">
                    Professional, patient-focused dental care for healthier smiles in Liluah, Howrah.
                </p>
            </div>

            <div>
                <h3 className="text-sm font-semibold uppercase tracking-[0.15em] text-white mb-5">Quick Links</h3>
                <ul className="space-y-3">
                    {quickLinks.map((l) => (
                        <li key={l.href}>
                            <a
                                href={l.href}
                                data-testid={`footer-link-${l.label.toLowerCase()}`}
                                className="text-sm text-slate-400 transition-colors duration-200 hover:text-teal-400"
                            >
                                {l.label}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>

            <div>
                <h3 className="text-sm font-semibold uppercase tracking-[0.15em] text-white mb-5">Contact</h3>
                <div className="flex gap-3 mb-4">
                    <MapPin className="h-5 w-5 text-teal-500 shrink-0 mt-0.5" strokeWidth={1.8} />
                    <address className="not-italic text-sm leading-relaxed text-slate-400">
                        Ward No. 34, 117/13, Mirpara Rd, PO Bhattanagar, Bhatta Nagar, Liluah, Howrah, West Bengal 711203
                    </address>
                </div>
                <div className="flex gap-3 items-center">
                    <Phone className="h-5 w-5 text-teal-500 shrink-0" strokeWidth={1.8} />
                    <a href={PHONE_TEL} data-testid="footer-phone-link" className="text-sm text-slate-300 transition-colors duration-200 hover:text-teal-400">
                        {PHONE_DISPLAY}
                    </a>
                </div>
            </div>
        </div>

        <div className="border-t border-slate-800/80">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
                <p className="text-xs text-slate-500" data-testid="footer-copyright">
                    © 2026 The Tooth Care Dental Clinic. All rights reserved.
                </p>
                <div className="flex items-center gap-6">
                    <a href="#home" data-testid="footer-privacy-link" className="text-xs text-slate-500 transition-colors duration-200 hover:text-teal-400">
                        Privacy Policy
                    </a>
                    <a href="#home" data-testid="footer-terms-link" className="text-xs text-slate-500 transition-colors duration-200 hover:text-teal-400">
                        Terms
                    </a>
                </div>
            </div>
        </div>
    </footer>
);
